import { selectCurrentAccount, selectCurrentActiveSubscription, selectCurrentSubscription } from "fond/api";
import { Subscription } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

/**
 * Gets the current subscription of the current (or only) account.
 */
export const useGetCurrentSubscription = (): Subscription | undefined => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const currentSubscription = useAppSelector((state) => currentAccount && selectCurrentSubscription(state, currentAccount.ID));
  return currentSubscription || undefined;
};

export const useGetCurrentActiveSubscription = (): Subscription | undefined => {
  const currentAccount = useAppSelector(selectCurrentAccount);
  const currentSubscription = useAppSelector((state) => currentAccount && selectCurrentActiveSubscription(state, currentAccount.ID));
  return currentSubscription || undefined;
};
